import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const ControlPanelSelect = ({
  value,
  onChange,
  label,
  options = [],
  fullWidth = true,
  size = "small",
}) => {
  return (
    <FormControl fullWidth={fullWidth} size={size}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={onChange} label={label}>
        {options.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ControlPanelSelect;
